import { Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from 'react';
import { cssToken } from '@youhelp-ru/ui';
import { TooltipProps, TooltipStateProps } from '../model';

const name = 'Tooltip';
export const TooltipTokens = {
  ColorBg: cssToken(name, ['color', 'bg']),
  ColorText: cssToken(name, ['color', 'text']),
  ColorBorder: cssToken(name, ['color', 'border']),
};
export const StyledTooltip = styled(({ className, ...props }: TooltipProps & { ownerState: Required<TooltipStateProps> }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, ownerState }) => {
  const { colorSchema, bordered } = ownerState;

  const tooltipBodyStyles = {
    marginTop: '0.71em !important',
    marginBottom: '0 !important',
    ...theme.typography['caption bold'],
    borderRadius: `${theme.borderRadius.small}px`,
    padding: '0 !important',
  };

  const colorSchemaToStyles = {
    error: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette['brand pink']),
      color: TooltipTokens.ColorText(theme.palette.white),
    },
    light: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette['gray light']),
      color: TooltipTokens.ColorText(theme.palette['brand gray']),
    },
    white: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette.white),
      color: TooltipTokens.ColorText(theme.palette['brand gray']),
      border: `1px solid ${TooltipTokens.ColorBorder(theme.palette['gray dark'])}`,
    },
    dark: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette['brand gray']),
      color: TooltipTokens.ColorBg(theme.palette.white),
    },
    secondary: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette['gray']),
      color: TooltipTokens.ColorText(theme.palette.white),
    },
    success: {
      backgroundColor: TooltipTokens.ColorBg(theme.palette.green),
      color: TooltipTokens.ColorText(theme.palette.white),
    },
  };

  const arrowStyles =
    colorSchema === 'white'
      ? {
          color: theme.palette.white,
          '&::before': {
            border: `1px solid ${theme.palette['gray dark']}`,
            backgroundColor: theme.palette.white,
          },
        }
      : {
          color: bordered ? TooltipTokens.ColorBorder(theme.palette.white) : colorSchemaToStyles[colorSchema].backgroundColor,
        };

  const schemaStyles = colorSchemaToStyles[colorSchema];

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      ...tooltipBodyStyles,
      ...schemaStyles,
      border:
        'border' in schemaStyles
          ? schemaStyles.border
          : bordered
            ? `2px solid ${TooltipTokens.ColorBorder(theme.palette.white)}`
            : undefined,
    },
    [`& .${tooltipClasses.arrow}`]: arrowStyles,
  };
});
